import { Injectable } from '@angular/core';
// noinspection SpellCheckingInspection
import Bowser, { Parser } from 'bowser';

@Injectable({
  providedIn: 'root'
})
export class BrowserCompatibilityService {

  private readonly browser: Parser.Parser;

  constructor() {
    this.browser = Bowser.getParser(window.navigator.userAgent);
  }


  isBrowserCompatible(): boolean {
    return this.browser.satisfies({
      chrome: '>87',
      edge: '>87',
      firefox: '>=84'
    });
  }

  isBrowserOutdated(): boolean {
    const browserSupported = this.browser.isBrowser('chrome', true)
      || this.browser.isBrowser('edge', true)
      || this.browser.isBrowser('firefox', true);
    return !this.isBrowserCompatible() && browserSupported;
  }
}
